
export default function PrivacyText() { 

  return (
      <div className="privacy">
        <h1>개인정보처리방침</h1>
        <div className="privacy_box">
         <p>곡성군청 (곡성군 스마트 안전지도) 는 정보주체의 자유와 권리 보호를 위해 「개인정보 보호법」및 관계 법령이 정한 바를 준수하여, 적법하게 개인정보를 처리하고 안전하게 관리하고 있습니다.</p>
         <p>이에 ｢개인정보 보호법｣ 제30조 에 따라 정보주체에게 개인정보의 처리와 보호에 관한 절차 및 기준을 안내하고, 이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 하기 위하여 다음과 같이 개인정보 처리방침을 수립·공개합니다.</p>
          <h5>개인정보의 처리목적</h5>
          <p>곡성군청 는 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 ｢개인정보 보호법｣ 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다. </p>
          <ol>
            <li>1. 회원 가입 및 관리<p>-회원가입 의사확인, 이용자 식별 및 인증,회원자격 유지 및 관리, 부정 이용 방지</p></li>
            <li>2. 서비스 제공<p>-주소기반안전지도제공,사용자 맞춤형 정보 제공, 위험알림 전달</p></li>
            <li>3. 스위치 상태 관리<p>-스위치 상태 모니터링</p></li>
            <li>4. 질병 관련 정보 기반 위험군 분류 및 안전관리 기능 제공<p>-사용자가 입력한 질병 정보(예: 만성질환 여부, 호흡기 질환 등)를 바탕으로 건강 취약군(위험군)으로 분류하여 긴급 알림 간격을 단축하여 집중적인 안전 정보 제공
            <span className="color01">※ 해당 정보는 진단서 기반이 아닌, 사용자의 입력 또는 선택에 의해 수집되는 민감정보이며,「개인정보 보호법」 제23조에 따라 별도의 동의를 받아 처리합니다.</span></p></li>
            <li>5. 위험군 조사 통계 분석<p>-사용자 이용 패턴 분석등을 통한 기능 개선 및 고도화</p></li>
          </ol>

          <h5>처리하는 개인정보 항목</h5>
          <p>곡성군청 은 다음과 같은 개인정보 법적 근거로 정보주체의 개인정보를 수집 및 이용합니다.</p>
          <ol>
          <li>1. 회원 서비스 운영
          <p>･ 법적 근거 : 「개인정보 보호법」 제15조제1항제4호(‘계약 체결·이행’)</p>
          <p>･ 수집·이용 항목 : ID, 비밀번호, 휴대전화번호, 이메일, 성명, 주소, 생년월일, 최근 접속 시간</p></li>
          <li>2. 질병 정보 기반 위험군 분류 및 안전관리 기능 제공
          <p>･ 법적 근거 :「개인정보 보호법」 제23조제1항제1호 (민감정보 처리 동의)</p>
          <p>･ 수집·이용 항목 : 사용자 상태(위험군 여부, 응급 요청 기록), 위험 알림 수신 간격</p></li>
          <li>3. 긴급 알림 및 맞춤형 안전 정보 제공
          <p>･ 법적 근거 :「개인정보 보호법」 제15조제1항제1호 (정보주체의 동의)</p>
          <p>･ 수집·이용 항목 : 사용자 상태 (위험군 여부, 응급 요청 기록), 위험 알림 간격</p></li>
          <li>4. 통계·분석 및 시스템 개선
          <p>･ 법적 근거 :「개인정보 보호법」 제28조의2 (가명정보의 처리)</p>
          <p>･ 수집·이용 항목 : 응급 알림 통계, 총 사용자 수 통계</p></li>
          <li>5. 스위치 사용 정보 기반 안전관리 기능 제공
          <p>･ 법적 근거 :「개인정보 보호법」 제23조제1항제1호 (민감정보 처리 동의)</p>
          <p>･ 수집·이용 항목 : 응급 알림 통계, 총 사용자 수 통계 </p>
            <p>･ 처리 목적 : 건강 취약군(위험군) 사용자의 행동 패턴 분석, 맞춤형 안전 서비스 제공</p></li>
          </ol>

          <h5>개인정보의 처리 및 보유기간</h5>
          <p>곡성군청 은 법령에 따른 개인정보 보유·이용 기간 또는 정보주체로부터 개인정보를 수집 시에동의받은 개인정보 보유·이용 기간 내에서 개인정보를 처리·보유합니다.</p>
          <div className="table">
            <table>
              <thead>
                <tr>
                  <th>처리 목적</th>
                  <th>수집 항목</th>
                  <th>보유 및 이용 기간</th>
                </tr>
              </thead>
              <tbody>
                  <tr>
                    <td>회원 서비스 운영</td>
                    <td>ID, 비밀번호, 성명, 생년월일, 주소, 이메일, 휴대전화번호, 최근 접속 시간</td>
                    <td>회원 탈퇴 시까지 (단, 관계 법령에 따라 보존 필요 시 해당 기간까지)</td>
                  </tr>
                  <tr>
                    <td>질병 정보 기반 위험군 분류 및 안전관리 기능 제공</td>
                    <td>사용자가 입력한 건강 정보(예: 만성질환 여부), 응급처치 횟수</td>
                    <td>별도 동의 철회 시까지 또는 서비스 종료 시까지</td>
                  </tr>
                  <tr>
                    <td>긴급 알림 및 맞춤형 안전 정보 제공</td>
                    <td>위험군 여부, 응급 요청 기록, 위험 알림 간격</td>
                    <td>서비스 제공 기간 동안 보유</td>
                  </tr>
                  <tr>
                    <td>통계·분석 및 시스템 개선</td>
                    <td>응급 알림 통계, 총 사용자 통계, 스위치 사용 통계 등</td>
                    <td>통계 목적의 경우 가명처리 후 보존, 원본 데이터는 수집 목적 달성 후 즉시 파기</td>
                  </tr>
                  <tr>
                    <td>스위치 사용 정보 기반 안전관리 기능 제공</td>
                    <td>스위치 사용 기록, 스위치 상태 정보</td>
                    <td>관련 서비스 제공 기간 동안 보유 (단, 개인정보와 연계되는 경우 별도 동의 철회 시까지)</td>
                  </tr>
                </tbody>
            </table>
          </div>
          <ul>
            <li><span className="color01">※ 단, 다음의 경우에는 해당 사유 종료 시까지 보유합니다.</span></li>

            <li>- 전자상거래 등에서의 소비자 보호에 관한 법률에 따른 계약 또는 청약철회 등에 관한 기록: 5년</li>
            <li>- 통신비밀보호법에 따른 서비스 이용기록, 접속 로그, 접속 IP 정보: 3개월</li>
            <li>- 기타 법령에 따른 보존이 필요한 경우 해당 법령에서 정한 기간</li>
          </ul>

          <h5>개인정보의 파기 절차 및 방법</h5>
          <ol>
            <li>① 곡성군청은 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는
            지체없이 해당 개인정보를 파기합니다.</li>
            <li>② 정보주체로부터 동의받은 개인정보 보유기간이 경과하거나 처리목적이 달성되었음에도 불구하고 다른 법령에
            따라 개인정보를 계속 보존하여야 하는 경우에는, 해당 개인정보를 별도의 데이터베이스(DB)로 옮기거나
            보관장소를 달리하여 보존합니다.
            <span className="color01">※ 다른 법령에 따라 보존하는 개인정보의 항목과 보존 근거는 ‘5. 개인정보의 처리 및 보유 기간’ 항목에서 확인 가능</span></li>
            <li>③ 개인정보 파기의 절차 및 방법은 다음과 같습니다.</li>
          </ol>

          <dl>
            <dt>파기절차</dt>
            <dd>곡성군청은 파기 사유가 발생한 개인정보를 선정하고,곡성군청의 개인정보 보호책임자의 승인을 받아 개인정보를 파기합니다.</dd>
            <dt>파기방법</dt>
            <dd>곡성군청은 전자적 파일 형태로 기록·저장된 개인정보는 기록을 재생할 수 없도록 파기하며, 종이 문서에 기록·저장된 개인정보는 분쇄기로 분쇄하거나 소각하여 파기합니다</dd>
          </dl>

          <h5>개인정보의 제3자 제공에 관한 사항</h5>
          <p>곡성군청은 정보주체의 개인정보를 &quot;개인정보의 수집 및 이용 목적&quot; 범위 내에서만 처리하며, 정보주체의 사전 동의 없이 제3자에게 제공하지 않습니다.</p>
          <p>다만, 다음의 경우에는 예외로 개인정보를 제공할 수 있습니다.</p>
          <ol>
            <li>- 정보주체로부터 별도의 동의를 받은 경우</li>
            <li>- 법령에 특별한 규정이 있는 경우</li>
            <li>- 정보주체 또는 제3자의 생명, 신체, 재산의 이익을 위하여 필요한 경우로서 정보주체의 동의를 받을 수 없는 정당한 사유가 있는 경우</li>
            <li>- 통계작성, 학술연구 등의 목적을 위하여 필요한 경우로서 특정 개인을 식별할 수 없는 형태로 제공하는 경우</li>
          </ol>
          <h5>정보주체와 법정대리인의 권리·의무 및 행사방법</h5>
          <ol>
            <li>① 정보주체는곡성군청에 대해 언제든지 개인정보 열람·전송·정정·삭제·처리정지 및 동의 철회 등
            을 요구(이하 “권리 행사”라 함)할 수 있습니다.
            <span className="color01">※ 14세 미만 아동의 권리 행사는 법정대리인이 직접 해야 하며, 14세 이상의 미성년자인 정보주체는 정보주체의 개인정보
            에 관하여 미성년자 본인이 권리를 행사하거나 법정대리인을 통하여 권리를 행사할 수 있습니다.</span></li>
            <li>② 권리 행사는 곡성군청에 대해 「개인정보 보호법 시행령」 제41조제1항에 따라 서면, 전화, 전자
            우편, 팩스(FAX), 인터넷 등을 통하여 하실 수 있으며, 곡성군청은 이에 대해 지체없이 조치
            하겠습니다.

            정보주체는 언제든지 홈페이지 ‘내정보 &gt; 회원정보’에서 개인정보를 직접 조회·수정·삭제·처리정지·동의
            철회하거나 ‘문의하기’를 통해 열람을 요청할 수 있습니다.
            정보주체는 언제든지 홈페이지 ‘내정보 &gt; 회원정보 &gt; 문의하기’를 통해 자동화된 결정의 거부 및 설명 요구가
            가능합니다.</li>
            <li>③ 권리 행사는 정보주체의 법정대리인이나 위임을 받은 자 등 대리인을 통하여 하실 수도 있습니다. 이 경우 “개인
            정보 처리 방법에 관한 고시” [별지 11] 서식에 따른 위임장을 제출하셔야 합니다.</li>
            <li>④ 정보주체가 개인정보 열람 및 처리 정지를 요구할 권리는 「개인정보 보호법」 제35조제4항 및 제37조제2항에
            의하여 제한될 수 있습니다.</li>
            <li>⑤ 다른 법령에서 그 개인정보가 수집 대상으로 명시되어 있는 경우에는 해당 개인정보의 삭제를 요구할 수 없습
            니다.</li>
            <li>⑥ 곡성군청은 권리 행사를 한 자가 본인이거나 정당한 대리인인지를 확인합니다.</li>
            <li>⑦ 정보주체는 권리 행사를 아래의 부서에 할 수 있습니다.곡성군청은 정보주체로부터 권리행사를 청구받은 날로부터 10일(전송요구의 경우 지체 없이) 이내 회신하겠습니다.
              <div className="txtbox">
                  <ul>
                    <li> ◎ 개인정보 권리 행사 청구 접수·처리 부서</li>
                    <li>부서명 : 군민활력과</li>
                    <li>주 소 : 전남 곡성군 곡성읍 학정3길 6</li>
                    <li>연락처 : 061-360-2423</li>
                  </ul>
                </div>
            </li>
          </ol>
          <h5>개인정보 보호책임자</h5>
          <ol>
            <li>①곡성군청은 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.
              <div className="txtbox">
                <ul>
                  <li> ◎ 개인정보 보호책임자</li>
                  <li>성명 : 노민정</li>
                  <li>직위 : 주무관</li>
                  <li>연락처 : 061-360-2423</li>
                </ul>
              </div>
              <div className="txtbox">
                  <ul>
                    <li> ◎ 개인정보보호 담당부서</li>
                    <li>부서명 : 군민활력과</li>
                    <li>연락처 : 061-360-2423</li>
                  </ul>
              </div>
            </li>
            <li>② 정보주체는 곡성군청의 서비스(또는 사업)를 이용하시면서 발생한 모든 개인정보보호 관련 문의,
          불만처리, 피해구제 등에 관한 사항을 개인정보 보호책임자 및 개인정보보호 담당부서로 문의할 수 있습니다.
          곡성군청은 정보주체의 문의에 대해 지체없이 답변 및 처리해 드릴 것입니다.</li>
          </ol>

          <h5>권익침해 구제방법</h5>
          <p>정보주체는 개인정보침해로 인한 구제를 받기 위하여 개인정보 분쟁조정위원회, 한국인터넷진흥원 개인정보침해 신고센터 등에 분쟁해결이나 상담 등을 신청할 수 있습니다. 이 밖에 기타 개인정보침해의 신고, 상담에 대하여는 아래의 기관에 문의하시기 바랍니다.</p>
          <div className="table02">
              <table>
                <tbody>
                  <tr>
                    <th>개인정보 분쟁조정위원회</th>
                    <td>(국번없이) 1833-6972 (<a href='http://www.kopico.go.kr' target='_blank' class='url'>www.kopico.go.kr</a>)</td>
                  </tr>
                  <tr>
                    <th>개인정보침해 신고센터</th>
                    <td>(국번없이) 118 (privacy.kisa.or.kr)</td>
                  </tr>
                  <tr>
                    <th>경찰청</th>
                    <td>(국번없이) 182 (ecrm.police.go.kr)</td>
                  </tr>
                </tbody>
              </table>
          </div>
        </div>
      </div>
  );
}
